import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { GigCardShell, Media, Price, GigBadges, Rating, SellerInfo, SellerLevel, Title, Username, CollectGig } from '../shared';
import { getCurrency, adaptGigData, getGigAssets, isRisingTalent, gigCardExperiments } from '../utils';
import { Avatar } from '@fiverr/fit';
import '@fiverr/globals';
import translations from '../translations.en.json';

// TODO: clean up isFooterReversed and make this a functional component
class GigCard extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            unmounting: false
        };

        i18n.add(translations);
    }

    isFooterReversed(abTests) {
        const avgMedVariations = [2, 3];

        return abTests && avgMedVariations.indexOf(abTests.AVG_MEDIAN_PRICE_2) > -1;
    }

    render() {
        const {
            user,
            updateCollections,
            gig,
            context
        } = this.props;
        const inExperiment = gigCardExperiments(context.abTests),
            userId = user && user.userId || null,
            risingTalent = isRisingTalent(gig.type),
            shouldRenderRating = (gig.rating > 0 || gig.is_pro) && !risingTalent,
            isLimitedEdition = gig.is_limited_edition,
            padGigCard = shouldRenderRating || (isLimitedEdition || risingTalent),
            limitDisplayedRatings = inExperiment('RATINGS_THRESHOLD_ONE_HUNDRED'),
            showHighCompletionRate = inExperiment('HIGH_COMPLETION_RATE_GIG_BADGE') && gig.high_completion_rate;


        adaptGigData(gig, {context});

        return (
            <GigCardShell cardType="card" key={gig.gig_id} type="mp-gig-card" gigId={gig.gig_id} cachedSlug={gig.cached_slug} position={gig.pos}>
                <a key={`title-link-${gig.gig_id}`} href={gig.gig_url} className="js-gig-card-imp-data">
                    <Media key={`media-${gig.gig_id}`} assets={getGigAssets(gig)} gigId={gig.gig_id} userId={userId}/>
                </a>
                <div className="gig-card-caption">
                    <SellerInfo>
                        {gig.is_seller_online && <span className="is-online"></span>}
                        <Avatar src={gig.seller_img}/>
                        <Username name={gig.seller_name} url={gig.seller_url}/>
                        {!risingTalent && <SellerLevel level={gig.seller_level} isPro={gig.is_pro} isLimitedEdition={isLimitedEdition} isNewSeller={gig.is_new_seller}/>}
                    </SellerInfo>
                    <Title gigUrl={gig.gig_url} caption={gig.iwill_title} classes={padGigCard ? '' : 'no-rating '}/>
                    {shouldRenderRating && !isLimitedEdition && <Rating score={gig.rating} votes={gig.rating_count} starSize={15} starCount={1} isPro={gig.is_pro} limitDisplayedRatings={limitDisplayedRatings}/>}
                    <GigBadges featured={gig.is_featured}
                        limitedEdition={gig.is_limited_edition}
                        limitedEditionDeadline={gig.limited_edition_expires_at}
                        qualityChoice={gig.quality_choice}
                        reliable={showHighCompletionRate}
                        availableNow={gig.is_available_now}
                        risingTalent={risingTalent}
                        sellerName={gig.seller_name}
                        pro={gig.is_pro}
                        gigId={gig.gig_id}/>
                </div>
                <footer className={`gig-card-footer${this.isFooterReversed(context.abTests) ? ' reversed' : ''}`}>
                    <CollectGig gigId={gig.gig_id} sellerId={gig.seller_id} updateCollections={updateCollections} user={user} showCollMenu={true} icon="ficon ficon-bars"/>
                    <Price gigUrl={gig.gig_url}
                        price={getCurrency(gig.price_i, true)}
                        showStartingAt={gig.show_starting_at}
                        isLimitedEdition={isLimitedEdition}
                        averagePrice={gig.average_price && getCurrency(gig.average_price, true)}
                        medianPrice={gig.median_price && getCurrency(gig.median_price, true)}/>
                </footer>
            </GigCardShell>
        );
    }
}

GigCard.propTypes = {
    user: PropTypes.object,
    gig: PropTypes.object,
    context: PropTypes.shape({
        pageCtxId: PropTypes.string,
        refCtxId: PropTypes.string,
        abTests: PropTypes.object
    })
};

GigCard.defaultProps = {
    context: {}
};

export default GigCard;



// WEBPACK FOOTER //
// ./src/mp_gig_card/GigCard.js